// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/page-intro-article/page-intro-article.component.scss
// module id = 432
// module chunks = 0